// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.dashboard-header h1 {
  color: #333;
  font-size: 2.5rem;
  margin: 0;
}

.view-all-damages-btn {
  background: var(--ar-buttons-bg);
  color: var(--main-text-color);
  padding: 12px 24px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 500;
  transition: background 0.3s;
}

.view-all-damages-btn:hover {
  background: var(--secondary-color);
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.stat-card {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s, box-shadow 0.3s;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.stat-card h3 {
  font-size: 2.5rem;
  margin: 0 0 8px 0;
  color: var(--main-text-color-highligth);
  font-weight: 700;
}

.stat-card p {
  color: #666;
  margin: 0;
  font-weight: 500;
}

/* Filters */
.dashboard-filters {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
  align-items: center;
  flex-wrap: wrap;
}

.search-box input {
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  min-width: 300px;
}

.search-box input:focus {
  outline: none;
  border-color: var(--secondary-color);
  box-shadow: 0 0 0 3px rgba(127, 204, 159, 0.1);
}

.status-filter {
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  background: white;
  cursor: pointer;
}

/* Projects Grid */
.projects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;
}

.project-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  transition: transform 0.3s, box-shadow 0.3s;
}

.project-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.project-image {
  height: 180px;
  overflow: hidden;
  position: relative;
}

.project-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.placeholder-image {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.placeholder-image span {
  color: white;
  font-size: 3rem;
  font-weight: 700;
}

.project-info {
  padding: 20px;
}

.project-info h3 {
  margin: 0 0 8px 0;
  font-size: 1.3rem;
  color: #333;
  font-weight: 600;
}

.project-description {
  color: #666;
  margin: 0 0 16px 0;
  line-height: 1.4;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.project-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.status-badge {
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
}

.location {
  font-size: 14px;
  color: #666;
}

.project-stats {
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
}

.project-stats span {
  color: #888;
  font-size: 14px;
}

.client {
  color: #666;
  font-size: 14px;
  margin: 0;
}

/* No Projects */
.no-projects {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}

.no-projects h3 {
  margin: 0 0 16px 0;
  font-size: 1.5rem;
}

.no-projects p {
  margin: 0;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-size: 1.2rem;
  color: #666;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .dashboard {
    padding: 15px;
  }
  
  .dashboard-header {
    flex-direction: column;
    gap: 20px;
    align-items: stretch;
  }
  
  .dashboard-filters {
    flex-direction: column;
    gap: 15px;
  }
  
  .search-box input {
    min-width: auto;
    width: 100%;
  }
  
  .status-filter {
    width: 100%;
  }
  
  .projects-grid {
    grid-template-columns: 1fr;
  }
  
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".dashboard {\r\n  padding: 20px;\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.dashboard-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.dashboard-header h1 {\r\n  color: #333;\r\n  font-size: 2.5rem;\r\n  margin: 0;\r\n}\r\n\r\n.view-all-damages-btn {\r\n  background: var(--ar-buttons-bg);\r\n  color: var(--main-text-color);\r\n  padding: 12px 24px;\r\n  border-radius: 8px;\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n  transition: background 0.3s;\r\n}\r\n\r\n.view-all-damages-btn:hover {\r\n  background: var(--secondary-color);\r\n}\r\n\r\n/* Stats Grid */\r\n.stats-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: 20px;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.stat-card {\r\n  background: white;\r\n  padding: 24px;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n  text-align: center;\r\n  transition: transform 0.3s, box-shadow 0.3s;\r\n}\r\n\r\n.stat-card:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.stat-card h3 {\r\n  font-size: 2.5rem;\r\n  margin: 0 0 8px 0;\r\n  color: var(--main-text-color-highligth);\r\n  font-weight: 700;\r\n}\r\n\r\n.stat-card p {\r\n  color: #666;\r\n  margin: 0;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Filters */\r\n.dashboard-filters {\r\n  display: flex;\r\n  gap: 20px;\r\n  margin-bottom: 30px;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.search-box input {\r\n  padding: 12px 16px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  font-size: 16px;\r\n  min-width: 300px;\r\n}\r\n\r\n.search-box input:focus {\r\n  outline: none;\r\n  border-color: var(--secondary-color);\r\n  box-shadow: 0 0 0 3px rgba(127, 204, 159, 0.1);\r\n}\r\n\r\n.status-filter {\r\n  padding: 12px 16px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  font-size: 16px;\r\n  background: white;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Projects Grid */\r\n.projects-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\r\n  gap: 24px;\r\n}\r\n\r\n.project-card {\r\n  background: white;\r\n  border-radius: 16px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\r\n  overflow: hidden;\r\n  text-decoration: none;\r\n  color: inherit;\r\n  transition: transform 0.3s, box-shadow 0.3s;\r\n}\r\n\r\n.project-card:hover {\r\n  transform: translateY(-8px);\r\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.project-image {\r\n  height: 180px;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.project-image img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.placeholder-image {\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.placeholder-image span {\r\n  color: white;\r\n  font-size: 3rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.project-info {\r\n  padding: 20px;\r\n}\r\n\r\n.project-info h3 {\r\n  margin: 0 0 8px 0;\r\n  font-size: 1.3rem;\r\n  color: #333;\r\n  font-weight: 600;\r\n}\r\n\r\n.project-description {\r\n  color: #666;\r\n  margin: 0 0 16px 0;\r\n  line-height: 1.4;\r\n  overflow: hidden;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n}\r\n\r\n.project-meta {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-bottom: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.status-badge {\r\n  color: white;\r\n  padding: 6px 12px;\r\n  border-radius: 20px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.location {\r\n  font-size: 14px;\r\n  color: #666;\r\n}\r\n\r\n.project-stats {\r\n  display: flex;\r\n  gap: 16px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.project-stats span {\r\n  color: #888;\r\n  font-size: 14px;\r\n}\r\n\r\n.client {\r\n  color: #666;\r\n  font-size: 14px;\r\n  margin: 0;\r\n}\r\n\r\n/* No Projects */\r\n.no-projects {\r\n  text-align: center;\r\n  padding: 60px 20px;\r\n  color: #666;\r\n}\r\n\r\n.no-projects h3 {\r\n  margin: 0 0 16px 0;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.no-projects p {\r\n  margin: 0;\r\n}\r\n\r\n.loading {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 200px;\r\n  font-size: 1.2rem;\r\n  color: #666;\r\n}\r\n\r\n/* Mobile Responsive */\r\n@media (max-width: 768px) {\r\n  .dashboard {\r\n    padding: 15px;\r\n  }\r\n  \r\n  .dashboard-header {\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    align-items: stretch;\r\n  }\r\n  \r\n  .dashboard-filters {\r\n    flex-direction: column;\r\n    gap: 15px;\r\n  }\r\n  \r\n  .search-box input {\r\n    min-width: auto;\r\n    width: 100%;\r\n  }\r\n  \r\n  .status-filter {\r\n    width: 100%;\r\n  }\r\n  \r\n  .projects-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .stats-grid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
